import axios, { AxiosResponse } from 'axios';
import EnvWindow from '../../utils/env';
import {
  IActivePermissionsDetails,
  IRoleForEditing,
  IRoleAndPermissionsResponse,
  IRoleDeleteResult,
  IRoleDetails,
  IRoleForUser,
} from './rolesAndPermissions.types';

export async function getRolesAndPermissions(
  pageNumber: number,
  pageSize: number,
): Promise<AxiosResponse<IRoleAndPermissionsResponse>> {
  return await axios.get(`${EnvWindow.REACT_APP_ROLES_API_URL}?pageNumber=${pageNumber}&pageSize=${pageSize}`);
}

export async function verifyDuplicateRoleName(roleName: string): Promise<boolean> {
  const response = await axios.get(`${EnvWindow.REACT_APP_USERS_API_URL}/Verification/Role/${roleName}`);
  return response.data;
}

export const getRoleWithPermissions = async (id: string): Promise<AxiosResponse<IRoleDetails>> => {
  return await axios.get(`${EnvWindow.REACT_APP_ROLES_API_URL}/${id}/claims`);
};

export async function createRoleName(roleName: string, description: string): Promise<AxiosResponse> {
  return await axios.post(EnvWindow.REACT_APP_ROLES_API_URL, {
    newRoleName: roleName,
    newDescription: description,
  });
}

export async function setRoleWithPermissions(
  roleId: string,
  active: string[],
  inActive: string[],
): Promise<AxiosResponse> {
  return await axios.put(`${EnvWindow.REACT_APP_ROLES_API_URL}/${roleId}/claims`, {
    roleId, // todo to be removed
    toActivate: active,
    deactivate: inActive,
  });
}

export const deleteRole = async (roleId: string): Promise<AxiosResponse<IRoleDeleteResult>> => {
  return await axios.delete(`${EnvWindow.REACT_APP_ROLES_API_URL}/${roleId}/delete`);
  // return await axios.delete(`${EnvWindow.REACT_APP_ROLES_API_URL}/` + roleId + '/delete');
};

export async function updateRole(id: string, newRoleName: string, newDescription: string): Promise<AxiosResponse> {
  return await axios.put(`${EnvWindow.REACT_APP_ROLES_API_URL}/${id}`, {
    id,
    newRoleName,
    newDescription,
  });
}

export async function getRole(roleId: string): Promise<AxiosResponse<IRoleForEditing>> {
  return await axios.get(`${EnvWindow.REACT_APP_ROLES_API_URL}/${roleId}`);
}

export const getUserRoles = async (userId: string): Promise<AxiosResponse<IRoleForUser[]>> => {
  return await axios.get(`${EnvWindow.REACT_APP_USERS_API_URL}/User/${userId}/role`);
};

export const getUserRolesActivePermissions = async (
  roleId: string,
): Promise<AxiosResponse<IActivePermissionsDetails[]>> => {
  return await axios.get(`${EnvWindow.REACT_APP_ROLES_API_URL}/${roleId}/claimsDescription`);
};

export async function setRolesForUser(userId: string, active: string[], inActive: string[]): Promise<AxiosResponse> {
  return await axios.put(`${EnvWindow.REACT_APP_USERS_API_URL}/User/${userId}/roles`, {
    userId,
    toActivate: active,
    deactivate: inActive,
  });
}
